// Optional-analytics consent. Product-approved copy, reproduced verbatim.
//
// EVERY STRING HERE IS THE CONSENT RECORD. This is the wording someone is
// answering, so nothing in this file may be paraphrased, shortened for layout,
// or "improved" — a banner whose text drifted from what Product approved is a
// banner collecting an answer to a different question. `approvedCopy.test.ts`
// pins them character for character.
//
// Spanish is complete here, which is unusual for this catalogue and is the
// point: core.ts explains that `es` carries only strings Product has approved,
// and Product approved all of these together with the English.

export const en = {
  "consent.banner.title": "Help improve Lura",
  "consent.banner.body":
    "With your permission, Lura uses optional analytics cookies to understand how people move through booking and where they run into problems. We don’t use this information for advertising.",
  "consent.action.allow": "Allow analytics",
  "consent.action.decline": "Continue without analytics",
  "consent.link.privacy": "Privacy notice",
  "consent.link.settings": "Cookie settings",

  "consent.settings.title": "Cookie settings",
  "consent.settings.label": "Optional analytics",
  "consent.settings.description":
    "Allow Lura to collect limited booking-journey analytics so we can understand where the experience needs improvement. This information is not used for advertising.",
  "consent.settings.choiceOn": "Allow analytics",
  "consent.settings.choiceOff": "Keep analytics off",
  "consent.settings.save": "Save settings",
  "consent.settings.close": "Close",

  "consent.status.withdrawn": "Analytics are now off. You can change this setting at any time.",

  "consent.failure.title": "We couldn’t save your setting",
  "consent.failure.body": "Analytics remain off. Try again when you’re ready.",
  "consent.failure.action": "Try again",
} as const;
